import { FaCheckCircle } from "react-icons/fa";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import "./reviewCard.css";

const ReviewCard = ({ review }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`star-${i}`} color="gold" />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half-star" color="gold" />);
    }

    while (stars.length < 5) {
      stars.push(<FaRegStar key={`empty-${stars.length}`} color="gold" />);
    }

    return stars;
  };

  return (
    <div className="review-card">
      <div className="review-stars">{renderStars(review.rating)}</div>

      <div className="review-user">
        <strong>{review.userName || "Anonymous"}</strong>
        <FaCheckCircle color="green" className="verified-icon" />
      </div>

      <p className="review-comment">"{review.comment}"</p>

      <p className="review-date">Posted on {formatDate(review.postedAt)}</p>
    </div>
  );
};

export default ReviewCard;
